import React, { ReactNode } from 'react';

import vehicleFormSchema, { VehicleFormSchema } from 'core/schemas/vehicleForm';
import { Form, FormSubmitHandler } from 'Elements/Form';

type Props = {
  onSubmit: FormSubmitHandler<VehicleFormSchema>;
  vehicle?: Partial<VehicleFormSchema['vehicle']>;
  children: ReactNode;
  id?: number;
};

export default function VehicleForm({
  onSubmit,
  vehicle,
  children,
  id: vehicleId
}: Props) {
  return (
    <Form
      validationSchema={vehicleFormSchema.meta({ vehicleId })}
      onSubmit={onSubmit}
      initialValues={{ vehicle }}
    >
      {children}
    </Form>
  );
}
